module.exports = __webpack_public_path__ + "static/img/cooperationNew.e6979ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperationNew.png
// module id = lkyN
// module chunks = 0